import { serverMetadataCookieSchema } from '@onramp/shared/serverMetadata.schema';

import { getCookie } from './cookies/clientUtils';

export function getServerMetadata() {
  return serverMetadataCookieSchema.parse(getCookie({ cookieName: 'serverMetadata' }));
}
